import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const LuxfricaIcon: FC<
  DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (
  <svg
  className={className}
    width="150"
    height="37"
    viewBox="0 0 150 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2404 9.01442H21.6346V18.0288C21.6346 23.0074 25.6705 27.0433 30.649 27.0433C35.6276 27.0433 39.6635 23.0074 39.6635 18.0288V9.01442H36.0577V18.0288C36.0577 21.016 33.6362 23.4375 30.649 23.4375C27.6619 23.4375 25.2404 21.016 25.2404 18.0288V9.01442Z"
      fill="black"
    />
    <path
      d="M119.956 24.403C118.695 25.6637 117.089 26.5222 115.34 26.8701C113.592 27.2179 111.779 27.0394 110.132 26.3571C108.485 25.6748 107.077 24.5194 106.087 23.037C105.096 21.5546 104.567 19.8117 104.567 18.0288C104.567 16.246 105.096 14.5031 106.087 13.0207C107.077 11.5383 108.485 10.3829 110.132 9.70061C111.779 9.01833 113.592 8.83981 115.34 9.18763C117.089 9.53546 118.695 10.394 119.956 11.6547L117.406 14.2043C116.65 13.4479 115.686 12.9328 114.637 12.7241C113.588 12.5154 112.5 12.6225 111.512 13.0319C110.524 13.4413 109.679 14.1345 109.085 15.024C108.49 15.9134 108.173 16.9591 108.173 18.0288C108.173 19.0986 108.49 20.1443 109.085 21.0337C109.679 21.9232 110.524 22.6164 111.512 23.0258C112.5 23.4352 113.588 23.5423 114.637 23.3336C115.686 23.1249 116.65 22.6098 117.406 21.8533L119.956 24.403Z"
      fill="black"
    />
    <path d="M96.274 9.01442H99.8798V27.0433H96.274V9.01442Z" fill="black" />
    <path
      d="M45.8153 27.0433L52.2837 20.5749L58.752 27.0433L61.2981 24.4972L54.8297 18.0288L61.2981 11.5605L58.752 9.01442L52.2837 15.4828L45.8153 9.01442L43.2692 11.5605L49.7376 18.0288L43.2692 24.4972L45.8153 27.0433Z"
      fill="black"
    />
    <path
      d="M82.9327 18.0288C82.9327 16.8451 83.1659 15.6729 83.6189 14.5792C84.0719 13.4855 84.7359 12.4917 85.573 11.6547C86.41 10.8176 87.4038 10.1536 88.4974 9.7006C89.5911 9.24758 90.7633 9.01442 91.9471 9.01442L91.9471 12.6202C91.2368 12.6202 90.5335 12.7601 89.8773 13.0319C89.2211 13.3037 88.6249 13.7021 88.1226 14.2043C87.6204 14.7066 87.222 15.3028 86.9502 15.959C86.6784 16.6152 86.5385 17.3186 86.5385 18.0288V27.0433H82.9327V18.0288Z"
      fill="black"
    />
    <path
      d="M69.9519 9.01442C69.9519 7.83063 70.1851 6.65843 70.6381 5.56475C71.0911 4.47107 71.7551 3.47733 72.5922 2.64026C73.4293 1.80319 74.423 1.1392 75.5167 0.686179C76.6104 0.233163 77.7826 -1.14306e-06 78.9664 0L78.9664 3.60577C78.2561 3.60577 77.5528 3.74567 76.8966 4.01748C76.2403 4.28929 75.6441 4.68768 75.1419 5.18992C74.6396 5.69216 74.2412 6.28841 73.9694 6.94462C73.6976 7.60083 73.5577 8.30415 73.5577 9.01442V16.226H78.9664V19.8317H73.5577V27.0433C73.5577 28.2271 73.3245 29.3993 72.8715 30.4929C72.4185 31.5866 71.7545 32.5804 70.9174 33.4174C70.0804 34.2545 69.0866 34.9185 67.9929 35.3715C66.8993 35.8245 65.7271 36.0577 64.5433 36.0577V32.4519C65.2535 32.4519 65.9569 32.312 66.6131 32.0402C67.2693 31.7684 67.8655 31.37 68.3678 30.8678C68.87 30.3655 69.2684 29.7693 69.5402 29.1131C69.812 28.4569 69.9519 27.7535 69.9519 27.0433V19.8317H64.5433V16.226H69.9519V9.01442Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M131.611 27.0433C126.632 27.0433 122.596 23.0074 122.596 18.0288C122.596 13.0503 126.632 9.01442 131.611 9.01442C136.589 9.01442 140.625 13.0503 140.625 18.0288V27.0433H137.019V25.241C135.513 26.3727 133.64 27.0433 131.611 27.0433ZM131.611 23.4375C128.623 23.4375 126.202 21.016 126.202 18.0288C126.202 15.0417 128.623 12.6202 131.611 12.6202C134.598 12.6202 137.019 15.0417 137.019 18.0288C137.019 21.016 134.598 23.4375 131.611 23.4375Z"
      fill="black"
    />
    <path d="M0 0H3.60577V23.4375H18.0288V27.0433H0V0Z" fill="black" />
    <path
      d="M142.999 1.84281V5.625H141.953V1.84281H140.625V0.9375H144.327V1.84281H142.999Z"
      fill="black"
    />
    <path
      d="M148.954 2.67436L147.686 5.23605H147.063L145.802 2.67436V5.625H144.756V0.9375H146.171L147.378 3.51261L148.592 0.9375H150V5.625H148.954V2.67436Z"
      fill="black"
    />
  </svg>
);
